// extracted by mini-css-extract-plugin
export default {"text":"ERd9G","modalButton":"abb7A","textContainer":"iIlMp","banner":"+LW7p","button":"N0n6A","logo":"riWJM"};